// src/pages/Parents.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Parents() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#9BE7FF] via-[#FDF7FF] to-[#FFE8C7] text-slate-900">
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="flex items-start justify-between gap-4">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">
            Parents
          </h1>

          <button
            onClick={() => nav("/home")}
            className="px-4 py-2 rounded-full bg-white/90 border border-slate-200 shadow-sm hover:bg-white"
            style={{ touchAction: "manipulation" }}
          >
            ← Back to Home
          </button>
        </div>

        <p className="mt-4 text-slate-800 leading-7">
          Piano With Pan is designed to be <span className="font-bold">kid-friendly</span>{" "}
          and easy to use, even independently. That said, your support makes the
          experience smoother and more fun — especially in the first few levels.
        </p>

        <div className="mt-6 grid gap-4">
          <section className="rounded-2xl border bg-white/90 backdrop-blur p-5 shadow-sm">
            <h2 className="text-xl font-extrabold">✅ Safe & Simple</h2>
            <ul className="mt-2 list-disc pl-5 text-slate-700 space-y-2">
              <li>
                The game is built so kids can follow the story + play along with
                clear on-screen guidance.
              </li>
              <li>
                Best for: <span className="font-bold">ages 5–12</span> (but
                younger kids may need help with setup).
              </li>
              <li>
                We recommend playing in a shared space for the first few sessions.
              </li>
            </ul>
          </section>

          <section className="rounded-2xl border bg-white/90 backdrop-blur p-5 shadow-sm">
            <h2 className="text-xl font-extrabold">🎤 Microphone + Piano Setup Tips</h2>
            <ul className="mt-2 list-disc pl-5 text-slate-700 space-y-2">
              <li>
                If your child is using a <span className="font-bold">real piano</span>,
                please help them:
                <ul className="mt-2 list-disc pl-5 space-y-1">
                  <li>Turn the laptop/phone microphone input up (if needed).</li>
                  <li>Increase the piano volume to a comfortable level.</li>
                  <li>Keep background noise low (TV/fans can confuse note detection).</li>
                </ul>
              </li>
              <li>
                If mic detection feels tricky, your child can always use the{" "}
                <span className="font-bold">Virtual Piano</span> to play the notes.
              </li>
            </ul>
          </section>

          <section className="rounded-2xl border bg-white/90 backdrop-blur p-5 shadow-sm">
            <h2 className="text-xl font-extrabold">👨‍👩‍👧 Best Way to Play Together</h2>
            <ul className="mt-2 list-disc pl-5 text-slate-700 space-y-2">
              <li>
                Sit with your child and treat it like a short “music game time”
                (10–15 minutes is perfect).
              </li>
              <li>
                Celebrate small wins — even getting 3 notes correct in a row is progress.
              </li>
              <li>
                Encourage them to repeat a level if needed. Repetition is part of learning music.
              </li>
            </ul>
          </section>

          <section className="rounded-2xl border bg-white/90 backdrop-blur p-5 shadow-sm">
            <h2 className="text-xl font-extrabold">🏆 The Trophy Goal</h2>
            <p className="mt-2 text-slate-700 leading-7">
              At the end, ask your child to show you their trophy! 🎉
              The special trophy is unlocked only when{" "}
              <span className="font-bold">all 10 songs</span> are completed successfully.
            </p>
            <p className="mt-2 text-slate-700 leading-7">
              It’s a fun way to build a goal mindset — and kids LOVE showing parents
              their final win.
            </p>
          </section>
        </div>

        <div className="mt-8 rounded-2xl border bg-white/90 backdrop-blur p-5 shadow-sm">
          <h2 className="text-xl font-extrabold">Need help?</h2>
          <p className="mt-2 text-slate-700 leading-7">
            If something doesn’t feel right (mic not detecting, audio too low, etc.),
            you can message us from the Contact page — and we’ll guide you.
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            <button
              onClick={() => nav("/contact")}
              className="px-5 py-2 rounded-full bg-blue-600 text-white font-extrabold hover:brightness-105"
              style={{ touchAction: "manipulation" }}
            >
              Contact Support
            </button>
            <button
              onClick={() => nav("/pricing")}
              className="px-5 py-2 rounded-full bg-white border border-slate-200 font-extrabold hover:bg-slate-50"
              style={{ touchAction: "manipulation" }}
            >
              View Pricing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}